import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }

import { onMounted } from "vue";
import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import GroupPermission from "../../components/Settings/GroupPermission/GroupPermission.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import { useRolePermission } from "../../composables/useRolePermission";


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupPermissionPage',
  setup(__props) {

const {
  searchQuery,
  loading,
  filteredRoles,
  paginationConfig,
  fetchRoles,
  deleteRole,
} = useRolePermission();

onMounted(fetchRoles);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader),
    _createVNode(MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(BreadcrumbMenu, { pageTitle: "group_permission" }),
      _createVNode(GroupPermission, {
        roles: _unref(filteredRoles),
        "search-query": _unref(searchQuery),
        "pagination-config": _unref(paginationConfig),
        loading: _unref(loading),
        "onUpdate:searchQuery": _cache[0] || (_cache[0] = ($event: any) => (searchQuery.value = $event)),
        onDelete: _unref(deleteRole)
      }, null, 8, ["roles", "search-query", "pagination-config", "loading", "onDelete"]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(MainFooter)
    ])
  ], 64))
}
}

})